import { render } from "./ExpenseFormLink.vue?vue&type=template&id=bbe9fc22"
import script from "./ExpenseFormLink.vue?vue&type=script&lang=js"
export * from "./ExpenseFormLink.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__